import { ChevronDown } from '@carbon/icons-react';
import { PreferenceCardChangeRequest } from 'client';
import { zPreferenceCardChangeRequestStatus } from 'client/zod.gen';
import { PillButton } from 'routes/components/pill-button';
import { SelectFilterBase, SelectFilterOption } from 'routes/components/select-filter-base';

import { getFilterParamKey } from 'DesignSystem/features/table-context/filter-param';
import { Button } from 'DesignSystem/ui/button';
import { Label } from 'DesignSystem/ui/label';
import LongText from 'components/LongText';
import { FilterComponentProps } from 'types/react-table';

const options: Array<SelectFilterOption> = zPreferenceCardChangeRequestStatus.options.map((option) => ({
  label: option,
  value: option,
}));

export function StatusFilterPill(props: FilterComponentProps<PreferenceCardChangeRequest>) {
  return (
    <SelectFilterBase
      meta={props.meta}
      options={options}
      onOpenChange={(open) => {
        if (!open) {
          props.formRef?.current?.requestSubmit();
        }
      }}
    >
      {({ selectedOptions }) => (
        <PillButton
          label={props.meta?.label ?? ''}
          selectedOptions={selectedOptions}
          pinned={props.meta.filter?.pinned}
          param={getFilterParamKey(props.meta.filter?.param)}
        />
      )}
    </SelectFilterBase>
  );
}

export function StatusFilter(props: FilterComponentProps<PreferenceCardChangeRequest>) {
  return (
    <div className="flex flex-col gap-1">
      <Label>{props.meta?.label}</Label>
      <SelectFilterBase meta={props.meta} options={options}>
        {({ selectedOptions }) => (
          <Button variant="outline" className="w-full justify-between overflow-hidden">
            <span>
              {selectedOptions.length ? (
                <LongText text={selectedOptions.map((option) => option.label).join(', ')} />
              ) : (
                'All'
              )}
            </span>
            <ChevronDown />
          </Button>
        )}
      </SelectFilterBase>
    </div>
  );
}
